import { render, staticRenderFns } from "./EditarDiagnostico.vue?vue&type=template&id=0b34ebce&"
import script from "./EditarDiagnostico.vue?vue&type=script&lang=js&"
export * from "./EditarDiagnostico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports